<template>
    <div class="neopark-dis-location">
        <div class="container">
            <div class="sectiont-title"><h2 v-html="salesCard.neopark_land_map.title"></h2></div>
            <div class="dis-map-container">
                <div class="col-left">
                    <div class="map-img" v-if="!isMobileChecker"><img :src="salesCard.neopark_land_map.img" alt=""></div>
                    <div class="neopark-location-map-mobile" v-else>
                        <img :src="salesCard.neopark_land_map.img" alt="" id="neopark-dis-mobile-map">
                    </div>
                </div>
                <div class="col-right">
                    <div class="map-title"><strong v-html="salesCard.neopark_land_map.title_num.num"></strong><span v-html="salesCard.neopark_land_map.title_num.num_title"></span></div>
                    <div class="map-desc" v-html="salesCard.neopark_land_map.desc"></div>
                    <div class="map-icons-list">
                        <div class="icon-item" v-for="item in salesCard.neopark_land_map.map_list">
                            <div class="icon-img"><img :src="item.icon" alt=""></div>
                            <p v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'neopark-dis-location',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initPinchZoomer() {
                var _self = this;
                var image = new Image();
                image.onload = function () {
                    if ($(window).width() < 800) {
                        $("#neopark-dis-mobile-map").pinchzoomer({
                            initZoom: .9,
                            minZoom: .9,
                            maxZoom: 5,
                        });
                    }
                }
                image.src = _self.salesCard.location_img;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initPinchZoomer();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/neopark/dis-location.scss';
    @import '@/styles/components/sales/sales-land-partials/neopark/respond/dis-location-respond.scss';
    // @import '@/styles/components/sales/respond/land-about-respond.scss';
</style>